import V from 'voca';
import ExpandableTextComponent from '72cms-ui/components/form-elements/ExpandableTextComponent';

export default {
    sections: ['details', 'image', 'header image', 'meta data'],
    groups: {

    },
    toolbar: [
        'add', 'edit', 'separator', 'active', 'preview', 'delete',
    ],
    fields: {
        name: {
            section: 'details',
            position: 0,
            description: '',
        },

        news_category_id: {
            label: 'Category',
            section: 'details',
            position: 1,
        },

        available_at: {
            label: 'Publish date',
            section: 'details',
            position: 3,
        },

        author: {
            section: 'details',
            position: 4,
            // component: ExpandableTextComponent,
        },

        duration: {
            section: 'details',
            position: 5,
            description:'example: 5 Min'
            // component: ExpandableTextComponent,
        },

        content: {
            section: 'details',
            position: 6,
            editorClass: 'copy',
        },

        image: {
            section: 'image',
            position: 0,
            description: 'Please resize images to 556px x 344px prior to uploading. The filesize of your image should not exceed <strong>400k</strong>.',
        },

        image_header: {
            section: 'header image',
            position: 1,
            description: 'Please resize images to 2000px x 555px prior to uploading. The filesize of your image should not exceed <strong>400k</strong>.',
        },

        title: {
            section: 'meta data',
            position: 1,
            listener: function (entry, entries, $form) {
                if (entry.name == 'name' && entry.newValue && !this.value) {
                    this.value = entry.newValue;
                }
            }
        },

        name_id: {
            label: 'Page URL',
            section: 'meta data',
            position: 2,
            description: 'This field will be populated based on page name if left blank',
            // prefix: '/news/',
            listener: function (entry, entries, $form) {
                if (entry.name == 'name' && entry.newValue && !this.value) {
                    this.value = V.slugify(entry.newValue);
                }
            }
        },

        meta_description: {
            section: 'meta data',
            position: 3,
            component: ExpandableTextComponent,
        },

        meta_keywords: {
            section: 'meta data',
            position: 4,
            component: ExpandableTextComponent,
        },
    }
}



// WEBPACK FOOTER //
// ./resources/assets/cms/js/config/form.news_post.js